import store from 'app/store';

export default function getUserToken() {
  const { auth } = store.get().getState();
  return auth.get('expires');
}
